import { getCookie } from '@/utils/cookie';
import isBrowser from '@/utils/isBrowser';

import type { PayloadItems } from './types';

const category: Record<string, string> = {
  ['Oura Sizing Kit']: 'Sizing Kit',
  ['Charger Set']: 'Charger Set',
  ['Oura Membership']: 'Subscription',
  ['2-Year Protection Plan']: 'Warranty',
  ['3-Year Protection Plan']: 'Warranty',
};

interface ConsentCookie {
  custom?: {
    marketing?: Record<string, boolean>;
  };
}

export const productCategory = (title: PayloadItems['title']): string => {
  return category[title!] ?? 'Ring';
};

const parseConsentCookie = (consentCookie: string): ConsentCookie => {
  try {
    return JSON.parse(decodeURIComponent(consentCookie)) as ConsentCookie;
  } catch (e) {
    // Shouldn't happen, but if for some reason the cookie is malformed, we don't want to break tracking
    return {};
  }
};

const hasConsent = () => {
  const consentCookie = getCookie('tracking-preferences');
  // if there is no tracking-preferences cookie we have to assume we cannot client-side track
  if (!consentCookie) return false;
  const parsedCookie = parseConsentCookie(consentCookie);
  const marketingConsent = parsedCookie.custom?.marketing;
  return Boolean(marketingConsent);
};

// TODO: Remove isOneTrustGateEnabled parameter after OneTrust CM rollout is complete
export const canUseClientSideAnalytics = (isOneTrustGateEnabled = false) => {
  if (!isBrowser()) return false;

  // Check for test flag that disables OneTrust
  if (
    (window as Window & { __DISABLE_ONETRUST_FOR_TESTS__?: boolean })
      .__DISABLE_ONETRUST_FOR_TESTS__
  ) {
    return hasConsent();
  }

  // TODO: Remove after OneTrust CM rollout
  // If OneTrust gate is enabled, ALWAYS use client-side analytics only
  // This prevents server events from leaking through during page load
  // Client-side tracking will be controlled by OneTrust consent state
  if (isOneTrustGateEnabled) {
    return true;
  }

  // Legacy consent manager: use server or client based on consent cookie
  return hasConsent();
};

// rdt_cid initially comes from the URL as a query parameter, which we then persist in a cookie
export const getRedditCid = (pageHref: string) => {
  const redditCidCookie = getCookie('_rdt_cid');
  const pageURL = new URL(pageHref);
  const searchParams = new URLSearchParams(pageURL.search);
  const redditCidQueryParam = searchParams.get('rdt_cid');

  // prioritizes new value from URL over existing cookie value
  if (redditCidQueryParam) {
    return redditCidQueryParam;
  }
  return redditCidCookie;
};
